module.exports = __webpack_public_path__ + "img/icone_upload_roxo_lilas.e6c70b10.png";